(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gutpet-ingredients"] && !Shopify.designMode) return;
  try {
    
  class GutpetIngredientsCarousel {
    constructor(container) {
      this.container = container;
      this.track = container.querySelector('.ingredients-track');
      this.originalSlides = Array.from(container.querySelectorAll('.ingredient-slide'));
      this.allSlides = this.originalSlides;
      this.prevBtn = container.querySelector('.ingredient-arrow--prev');
      this.nextBtn = container.querySelector('.ingredient-arrow--next');
      this.textArea = container.querySelector('.ingredients-text-area');
      this.textContainers = Array.from(container.querySelectorAll('.ingredient-text-container'));

      this.currentIndex = 0;
      this.autoplaySpeed = parseInt(container.dataset.autoplay) || 5000;
      this.autoplayEnabled = container.dataset.autoplayEnabled === 'true';
      this.textAnimation = container.dataset.textAnimation || 'fade';
      this.autoplayTimer = null;
      this.isTransitioning = false;

      this.init();
    }

    init() {
      if (this.originalSlides.length === 0) return;

      this.setupClones();
      this.allSlides = Array.from(this.track.children);

      this.updateCarousel(false);
      this.updateArrowState();
      this.updateTextContent(false);

      this.prevBtn?.addEventListener('click', () => this.prev());
      this.nextBtn?.addEventListener('click', () => this.next());

      this.addSwipeSupport();
      this.setupSlideNavigation();

      this.isHovering = false;
      this.isIntersecting = false;

      this.container.addEventListener('mouseenter', () => {
        this.isHovering = true;
        this.checkAutoplayState();
      });
      this.container.addEventListener('mouseleave', () => {
        this.isHovering = false;
        this.checkAutoplayState();
      });

      this.handleResize();
      this.setupVisibilityEvents();
    }

    setupVisibilityEvents() {
      this.handleVisibilityChange = () => this.checkAutoplayState();
      document.addEventListener('visibilitychange', this.handleVisibilityChange);

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.isIntersecting = entry.isIntersecting;
              this.checkAutoplayState();
            });
          },
          { threshold: 0.1 }
        );
        this.observer.observe(this.container);
      } else {
        this.isIntersecting = true;
        this.checkAutoplayState();
      }
    }

    checkAutoplayState() {
      if (!this.autoplayEnabled || this.originalSlides.length <= 1) return;

      if (this.isHovering || document.hidden || !this.isIntersecting) {
        this.stopAutoplay();
      } else {
        if (!this.autoplayTimer) {
          this.startAutoplay();
        }
      }
    }

    setupClones() {
      if (this.originalSlides.length <= 1) return;

      const fragmentEnd = document.createDocumentFragment();
      const fragmentStart = document.createDocumentFragment();

      this.originalSlides.forEach((slide) => {
        const cloneEnd = slide.cloneNode(true);
        cloneEnd.classList.add('is-clone');
        cloneEnd.setAttribute('aria-hidden', 'true');
        fragmentEnd.appendChild(cloneEnd);

        const cloneStart = slide.cloneNode(true);
        cloneStart.classList.add('is-clone');
        cloneStart.setAttribute('aria-hidden', 'true');
        fragmentStart.appendChild(cloneStart);
      });

      this.track.appendChild(fragmentEnd);
      this.track.insertBefore(fragmentStart, this.track.firstChild);
    }

    #domIndex() {
      return this.originalSlides.length > 1 ? this.currentIndex + this.originalSlides.length : this.currentIndex;
    }

    setupSlideNavigation() {
      this.originalSlides.forEach((slide, index) => {
        slide.addEventListener('click', () => {
          if (index === this.currentIndex) return;
          this.navigateToSlide(index);
        });
      });
    }

    navigateToSlide(targetIndex) {
      if (this.isTransitioning) return;
      if (targetIndex === this.currentIndex) return;

      const direction = targetIndex > this.currentIndex ? 'next' : 'prev';
      this.currentIndex = targetIndex;
      this.updateCarousel(true);
      this.updateTextContent(true, direction);
    }

    isMobile() {
      return window.innerWidth <= 749;
    }

    getSideSlideWidth() {
      const w = window.innerWidth;
      if (w <= 749) return w - 32;
      if (w <= 989) return 282;
      return 352;
    }

    getCenterSlideWidth() {
      const w = window.innerWidth;
      if (w <= 749) return w - 32;
      if (w <= 989) return 384;
      return 480;
    }

    getGap() {
      const w = window.innerWidth;
      if (w <= 749) return 16;
      if (w <= 989) return 19;
      return 24;
    }

    getCenterMargin() {
      const w = window.innerWidth;
      if (w <= 749) return 0;
      if (w <= 989) return 38;
      return 48;
    }

    updateCarousel(animate = true) {
      this.updateSlideStates();
      const offset = this.#calcOffset();

      if (animate && !this.isTransitioning) {
        this.track.style.transition = 'transform 0.6s cubic-bezier(0.2, 1, 0.3, 1)';
        this.isTransitioning = true;
        setTimeout(() => {
          this.isTransitioning = false;
        }, 600);
      } else {
        this.track.style.transition = 'none';
      }

      this.track.style.transform = `translateX(${offset.toFixed(2)}px)`;

      this.updateArrowState();
    }

    updateTextContent(animate = true, direction = 'next') {
      let normalizedIndex = this.currentIndex;
      const totalOriginals = this.originalSlides.length;
      if (totalOriginals > 0) {
        normalizedIndex = ((this.currentIndex % totalOriginals) + totalOriginals) % totalOriginals;
      }

      this.textContainers.forEach((container, index) => {
        const isActive = index === normalizedIndex;

        if (animate) {
          const wasActive = container.classList.contains('is-active') || container.dataset.wasActive === 'true';

          if (isActive) {
            if (container.leaveTimeout) clearTimeout(container.leaveTimeout);
            container.classList.remove('is-leaving', 'direction-next', 'direction-prev');
            container.classList.add('is-entering', `direction-${direction}`);
            requestAnimationFrame(() => {
              container.classList.add('is-active');
              container.classList.remove('is-entering');
            });
            container.dataset.wasActive = 'true';
          } else if (wasActive) {
            container.classList.remove('is-active', 'is-entering', 'direction-next', 'direction-prev');
            container.classList.add('is-leaving', `direction-${direction}`);
            container.dataset.wasActive = '';

            if (container.leaveTimeout) clearTimeout(container.leaveTimeout);
            container.leaveTimeout = setTimeout(() => {
              container.classList.remove('is-leaving', 'direction-next', 'direction-prev');
            }, 400);
          }
        } else {
          container.classList.remove('is-entering', 'is-leaving', 'direction-next', 'direction-prev');
          container.classList.toggle('is-active', isActive);
          if (isActive) container.dataset.wasActive = 'true';
          else container.dataset.wasActive = '';
        }
      });
    }

    updateSlideStates() {
      const targetDomIndex = this.#domIndex();

      this.allSlides.forEach((slide, domIdx) => {
        slide.classList.remove('is-center', 'is-visible', 'is-hidden', 'is-prev', 'is-next');

        if (domIdx === targetDomIndex) {
          slide.classList.add('is-center', 'is-visible');
        } else if (domIdx === targetDomIndex - 1) {
          slide.classList.add('is-visible', 'is-prev');
        } else if (domIdx === targetDomIndex + 1) {
          slide.classList.add('is-visible', 'is-next');
        } else {
          slide.classList.add('is-hidden');
        }
      });
    }

    updateArrowState() {
      const disable = this.originalSlides.length <= 1;
      if (this.prevBtn) this.prevBtn.disabled = disable;
      if (this.nextBtn) this.nextBtn.disabled = disable;
    }

    next() {
      if (!document.body.contains(this.container)) {
        this.stopAutoplay();
        return;
      }
      if (this.isTransitioning) return;
      if (this.originalSlides.length === 1) return;

      this.currentIndex++;
      this.updateCarousel(true);
      this.updateTextContent(true, 'next');

      if (this.currentIndex >= this.originalSlides.length) {
        setTimeout(() => this.#silentJump(0), 600);
      }
    }

    prev() {
      if (!document.body.contains(this.container)) {
        this.stopAutoplay();
        return;
      }
      if (this.isTransitioning) return;
      if (this.originalSlides.length === 1) return;

      this.currentIndex--;
      this.updateCarousel(true);
      this.updateTextContent(true, 'prev');

      if (this.currentIndex < 0) {
        setTimeout(() => this.#silentJump(this.originalSlides.length - 1), 600);
      }
    }

    #silentJump(targetIndex) {
      this.allSlides.forEach((s) => (s.style.transition = 'none'));
      this.track.style.transition = 'none';

      this.currentIndex = targetIndex;
      this.track.style.transform = `translateX(${this.#calcOffset().toFixed(2)}px)`;

      this.updateSlideStates();

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.allSlides.forEach((s) => (s.style.transition = ''));
        });
      });
    }

    #calcOffset() {
      const containerRect = this.container.getBoundingClientRect();
      const containerWidth = containerRect.width;
      const containerCenter = containerWidth / 2;

      const gap = this.getGap();
      const sideSlideWidth = this.getSideSlideWidth();
      const centerSlideWidth = this.getCenterSlideWidth();
      const centerMargin = this.getCenterMargin();

      let position = 0;
      const targetDomIndex = this.#domIndex();

      for (let i = 0; i < targetDomIndex; i++) {
        position += sideSlideWidth + gap;
      }
      position += centerMargin + centerSlideWidth / 2;

      let offset = containerCenter - position;

      if (window.innerWidth >= 750 && window.innerWidth <= 989 && this.currentIndex >= 1) {
        offset -= 70;
      }

      return offset;
    }

    addSwipeSupport() {
      let startX = 0;
      let startY = 0;
      let currentX = 0;
      let isDragging = false;
      let isHorizontal = null;
      let baseOffset = 0;

      const getBaseOffset = () => {
        const m = this.track.style.transform.match(/translateX\(([\d.-]+)px\)/);
        return m ? parseFloat(m[1]) : 0;
      };

      const onStart = (e) => {
        const touch = e.touches[0];
        startX = touch.clientX;
        startY = touch.clientY;
        currentX = startX;
        isDragging = true;
        isHorizontal = null;
        this.track.style.transition = 'none';
        baseOffset = getBaseOffset();
        this.isTransitioning = false;
        this.stopAutoplay();
      };

      const onMove = (e) => {
        if (!isDragging) return;
        const touch = e.touches[0];
        const dx = touch.clientX - startX;
        const dy = touch.clientY - startY;

        if (isHorizontal === null) {
          if (Math.abs(dx) > Math.abs(dy) + 3) {
            isHorizontal = true;
          } else if (Math.abs(dy) > Math.abs(dx) + 3) {
            isHorizontal = false;
          }
        }
        if (isHorizontal === false) return;
        if (isHorizontal) e.preventDefault();

        currentX = touch.clientX;
        const drag = currentX - startX;

        const isAtEdge = this.originalSlides.length <= 1;
        const resistance = 0.4;
        const delta = isAtEdge ? drag * resistance : drag;

        this.track.style.transform = `translateX(${(baseOffset + delta).toFixed(2)}px)`;
      };

      const onEnd = () => {
        if (!isDragging) return;
        isDragging = false;
        isHorizontal = null;

        const diff = startX - currentX;
        if (Math.abs(diff) > 40) {
          const direction = diff > 0 ? 'next' : 'prev';
          if (direction === 'next') {
            this.next();
          } else if (direction === 'prev') {
            this.prev();
          }
        } else {
          this.updateCarousel(true);
        }
        this.startAutoplay();
      };

      const targets = [this.track, this.textArea].filter(Boolean);
      targets.forEach((el) => {
        el.addEventListener('touchstart', onStart, { passive: true });
        el.addEventListener('touchmove', onMove, { passive: false });
        el.addEventListener('touchend', onEnd);
        el.addEventListener('touchcancel', onEnd);
      });
    }

    startAutoplay() {
      if (this.originalSlides.length === 1 || !this.autoplayEnabled) return;

      this.stopAutoplay();
      this.autoplayTimer = setInterval(() => {
        this.next();
      }, this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    handleResize() {
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          this.updateCarousel(false);
        }, 250);
      });
    }

    destroy() {
      this.stopAutoplay();
      this.prevBtn?.removeEventListener('click', this.prev);
      this.nextBtn?.removeEventListener('click', this.next);
      if (this.handleVisibilityChange) {
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      }
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }

  function lazyInitCarousels(root = document) {
    const carousels = root.querySelectorAll('.gutpet-ingredients-section .ingredients-carousel');
    const initCarousel = (carousel) => {
      if (!carousel || carousel.dataset.lazyInitialized === 'true') return;
      carousel.dataset.lazyInitialized = 'true';
      new GutpetIngredientsCarousel(carousel);
    };

    if (Shopify?.designMode) {
      carousels.forEach(initCarousel);
      return;
    }

    if (!('IntersectionObserver' in window)) {
      carousels.forEach(initCarousel);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          initCarousel(entry.target);
        });
      },
      { rootMargin: '300px 0px' }
    );

    carousels.forEach((carousel) => observer.observe(carousel));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => lazyInitCarousels(), { once: true });
  } else {
    lazyInitCarousels();
  }

  document.addEventListener('lazy-section-blocks:load', (event) => {
    lazyInitCarousels(event.target);
  });

  if (Shopify?.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      lazyInitCarousels(event.target);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gutpet-testimonial-option-2"] && !Shopify.designMode) return;
  try {
    
  class TestimonialOption2Carousel {
    constructor(container) {
      this.container = container;
      this.track = container.querySelector('.video-testimonials-track');
      this.originalSlides = Array.from(this.track.children);
      this.prevBtn = this.container.closest('.testimonials-container').querySelector('.chevron-button--prev');
      this.nextBtn = this.container.closest('.testimonials-container').querySelector('.chevron-button--next');

      this.autoplaySpeed = parseInt(container.dataset.autoplay) || 5000;
      this.slidesToShow = parseInt(container.dataset.slidesToShow) || 4;
      this.enableAutoplay = container.dataset.enableAutoplay !== 'false';
      this.autoplayTimer = null;
      this.isTransitioning = false;
      this.isVideoPlaying = false;
      this.currentSlideIndex = 0; // Index of the first visible slide in the *original* set

      this.init();
    }

    init() {
      if (this.originalSlides.length === 0) {
        this.prevBtn?.setAttribute('hidden', true);
        this.nextBtn?.setAttribute('hidden', true);
        return;
      }

      this.setupClones();
      this.updateSlides(); // Update this.slides to include clones
      this.setInitialPosition();
      this.updateArrowState();

      this.prevBtn?.addEventListener('click', () => this.prev());
      this.nextBtn?.addEventListener('click', () => this.next());

      this.addSwipeSupport();
      this.setupVisibilityObserver();
      this.setupVideoControls();
      this.startAutoplay();

      this.container.addEventListener('mouseenter', () => this.stopAutoplay());
      this.container.addEventListener('mouseleave', () => {
        if (!this.isVideoPlaying) this.startAutoplay();
      });

      this.handleResize();
    }

    setupClones() {
      // Only disable infinite loop if there's merely 1 slide
      if (this.originalSlides.length <= 1) {
        return;
      }

      const fragmentEnd = document.createDocumentFragment();
      const fragmentStart = document.createDocumentFragment();

      // Clone EXACTLY the original slides for both ends to ensure symmetry
      // and prevent visual whitespace gaps regardless of slidesToShow size
      this.originalSlides.forEach((slide) => {
        // Clones appended to end
        const cloneEnd = slide.cloneNode(true);
        cloneEnd.classList.add('is-clone');
        cloneEnd.setAttribute('aria-hidden', 'true');
        cloneEnd.setAttribute('inert', '');
        this.#eagerLoadVideo(cloneEnd);
        fragmentEnd.appendChild(cloneEnd);

        // Clones prepended to start (preserving identical order)
        const cloneStart = slide.cloneNode(true);
        cloneStart.classList.add('is-clone');
        cloneStart.setAttribute('aria-hidden', 'true');
        cloneStart.setAttribute('inert', '');
        this.#eagerLoadVideo(cloneStart);
        fragmentStart.appendChild(cloneStart);
      });

      // Insert pre/append fragments to fill out track
      this.track.appendChild(fragmentEnd);
      this.track.insertBefore(fragmentStart, this.track.firstChild);
    }

    // Eagerly resolve data-src on video sources inside a clone
    // so the video is ready when the infinite loop jumps to it
    #eagerLoadVideo(cloneEl) {
      const video = cloneEl.querySelector('video');
      if (!video) return;
      video.removeAttribute('autoplay');
      video.preload = 'none';
      const sources = video.querySelectorAll('source[data-src]');
      sources.forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      if (sources.length > 0) {
        video.dataset.loaded = 'true';
        video.load();
      }
    }

    // Preload a single original slide's video into browser buffer
    #preloadSlide(slide) {
      const video = slide.querySelector('video');
      if (!video || video.dataset.loaded) return;
      video.preload = 'none';
      const sources = video.querySelectorAll('source[data-src]');
      sources.forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      if (sources.length > 0) {
        video.dataset.loaded = 'true';
        video.load();
      }
    }

    // Release video buffer for a slide that's far from view to free RAM
    #releaseVideo(slide) {
      if (slide.classList.contains('is-clone')) return;
      const video = slide.querySelector('video');
      if (!video || !video.dataset.loaded || !video.paused) return;
      const sources = video.querySelectorAll('source');
      sources.forEach((source) => {
        if (source.src) {
          source.dataset.src = source.src;
          source.removeAttribute('src');
        }
      });
      delete video.dataset.loaded;
      video.load();
    }

    // Aggressively preload ALL original slides immediately to ensure no blank spaces.
    // We use a tiny 50ms stagger just to prevent blocking the main UI thread.
    #scheduleFullPreload() {
      this.originalSlides.forEach((slide, i) => {
        setTimeout(() => this.#preloadSlide(slide), i * 50);
      });
    }

    updateSlides() {
      this.slides = Array.from(this.track.children);
    }

    setInitialPosition() {
      // Initial position should be at the start of the original slides, past ALL prepended clones
      const initialOffset = -this.getSlideWidthWithGap() * this.originalSlides.length;
      this.track.style.transition = 'none';
      this.track.style.transform = `translateX(${initialOffset}px)`;
      this.currentSlideIndex = 0; // Represents the first *original* slide
      this.updateSlideStates();
      this.updateArrowState();
    }

    getSlideWidth() {
      const firstSlide = this.slides[0];
      if (firstSlide) {
        return firstSlide.offsetWidth;
      }
      return 288; // Fallback
    }

    getGap() {
      const computedGap = parseFloat(window.getComputedStyle(this.track).gap);
      return isNaN(computedGap) ? 24 : computedGap;
    }

    getSlideWidthWithGap() {
      return this.getSlideWidth() + this.getGap();
    }

    updateCarousel(animate = true) {
      this.pauseAllVideos();

      // Absolute offset is calculated from the start of the track (including prepended clones)
      const offset = -(this.currentSlideIndex + this.originalSlides.length) * this.getSlideWidthWithGap();

      if (animate && !this.isTransitioning) {
        this.track.style.transition = 'transform 0.6s cubic-bezier(0.2, 1, 0.3, 1)';
        this.isTransitioning = true;
        setTimeout(() => {
          this.isTransitioning = false;
        }, 600);
      } else {
        this.track.style.transition = 'none';
      }

      this.track.style.transform = `translateX(${offset}px)`;
      this.updateSlideStates();
      this.updateArrowState();
    }

    next() {
      if (this.isTransitioning) return;

      this.currentSlideIndex++;
      this.updateCarousel(true);

      if (this.currentSlideIndex >= this.originalSlides.length) {
        setTimeout(() => {
          this.currentSlideIndex = 0;
          this.setInitialPosition();
        }, 600);
      }
    }

    prev() {
      if (this.isTransitioning) return;

      this.currentSlideIndex--;
      this.updateCarousel(true);

      if (this.currentSlideIndex < 0) {
        // Jump back to the last original slide identically
        setTimeout(() => {
          this.currentSlideIndex = this.originalSlides.length - 1;
          const offset = -(this.currentSlideIndex + this.originalSlides.length) * this.getSlideWidthWithGap();
          this.track.style.transition = 'none';
          this.track.style.transform = `translateX(${offset}px)`;
          this.updateSlideStates();
        }, 600);
      }
    }

    updateSlideStates() {
      this.slides.forEach((slide, index) => {
        slide.classList.remove('is-active', 'is-visible', 'is-hidden');

        // Calculate the range of visible slides, accounting for full length clones
        const firstVisibleIndex = this.originalSlides.length + this.currentSlideIndex;
        const lastVisibleIndex = firstVisibleIndex + this.slidesToShow - 1;

        if (index >= firstVisibleIndex && index <= lastVisibleIndex) {
          slide.classList.add('is-visible');
          slide.setAttribute('aria-hidden', 'false');
          slide.removeAttribute('inert');
          if (index === firstVisibleIndex) {
            slide.classList.add('is-active');
          }
        } else {
          slide.classList.add('is-hidden');
          slide.setAttribute('aria-hidden', 'true');
          slide.setAttribute('inert', '');
        }
      });
    }

    updateArrowState() {
      // With infinite loop, arrows are always enabled unless there is 1 or fewer slides
      const disableArrows = this.originalSlides.length <= 1;
      if (this.prevBtn) {
        this.prevBtn.disabled = disableArrows;
      }
      if (this.nextBtn) {
        this.nextBtn.disabled = disableArrows;
      }
    }

    addSwipeSupport() {
      let startX = 0;
      let startY = 0;
      let currentX = 0;
      let isDragging = false;
      let isHorizontal = null;
      let baseOffset = 0;

      const getBaseOffset = () => {
        const m = this.track.style.transform.match(/translateX\(([\d.-]+)px\)/);
        return m ? parseFloat(m[1]) : 0;
      };

      const targets = [this.track];
      targets.forEach((el) => {
        el.addEventListener(
          'touchstart',
          (e) => {
            const touch = e.touches[0];
            startX = touch.clientX;
            startY = touch.clientY;
            currentX = startX;
            isDragging = true;
            isHorizontal = null;
            this.track.style.transition = 'none';
            baseOffset = getBaseOffset();
            this.isTransitioning = false;
            this.stopAutoplay();
          },
          { passive: true }
        );

        el.addEventListener(
          'touchmove',
          (e) => {
            if (!isDragging) return;
            const touch = e.touches[0];
            const dx = touch.clientX - startX;
            const dy = touch.clientY - startY;

            if (isHorizontal === null) {
              if (Math.abs(dx) > Math.abs(dy) + 3) {
                isHorizontal = true;
              } else if (Math.abs(dy) > Math.abs(dx) + 3) {
                isHorizontal = false;
              }
            }
            if (isHorizontal === false) return;
            if (isHorizontal) e.preventDefault();

            currentX = touch.clientX;
            const drag = currentX - startX;
            this.track.style.transform = `translateX(${(baseOffset + drag).toFixed(2)}px)`;
          },
          { passive: false }
        );

        const onEnd = () => {
          if (!isDragging) return;
          isDragging = false;
          isHorizontal = null;

          const diff = startX - currentX;
          if (Math.abs(diff) > 40) {
            if (diff > 0) {
              this.next();
            } else {
              this.prev();
            }
          } else {
            this.updateCarousel(true);
          }
          this.startAutoplay();
        };

        el.addEventListener('touchend', onEnd);
        el.addEventListener('touchcancel', onEnd);
      });
    }

    startAutoplay() {
      if (!this.enableAutoplay) return;
      if (this.originalSlides.length <= 1) return;

      this.stopAutoplay();
      this.autoplayTimer = setInterval(() => {
        this.next();
      }, this.autoplaySpeed);
    }

    pauseAllVideos() {
      const allVideos = this.container.querySelectorAll('video');
      allVideos.forEach((video) => {
        if (!video.paused) {
          video.pause();
        }
      });
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    setupVisibilityObserver() {
      // Pause/resume when section leaves viewport
      const sectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) {
              this.pauseAllVideos();
              this.startAutoplay();
            } else {
              // Section entered viewport: kick off full preload
              this.#scheduleFullPreload();
            }
          });
        },
        { rootMargin: '50px', threshold: 0.1 }
      );
      sectionObserver.observe(this.container);

      // Also schedule on init in case section is already visible
      setTimeout(() => this.#scheduleFullPreload(), 200);
    }

    setupVideoControls() {
      const manualVideos = this.container.querySelectorAll('video[data-manual-play]');

      manualVideos.forEach((video) => {
        const card = video.closest('.video-testimonial-card');
        const playButton = card?.querySelector('.video-play-button');

        if (!playButton || !card) return;

        const ensureVideoLoaded = () => {
          if (video.dataset.loaded === 'true') {
            if (video.readyState === 0) video.load();
            return;
          }

          const sources = video.querySelectorAll('source[data-src]');
          sources.forEach((source) => {
            source.src = source.dataset.src;
            source.removeAttribute('data-src');
          });

          if (sources.length === 0) return;

          video.dataset.loaded = 'true';
          video.preload = 'auto';
          video.load();
        };

        const markPlaying = (playing) => {
          video.classList.toggle('is-playing', playing);
          this.isVideoPlaying = playing;
          if (playing) {
            this.stopAutoplay();
          } else {
            this.startAutoplay();
          }
        };

        const attemptPlay = () => {
          ensureVideoLoaded();

          const startMutedPlayback = () => {
            video.muted = true;
            video.play().catch(() => {});
          };

          video.muted = false;
          const playPromise = video.play();

          if (playPromise !== undefined) {
            playPromise.catch(() => {
              startMutedPlayback();
            });
          }

          if (video.readyState < 2) {
            const handleReady = () => {
              if (video.paused) {
                startMutedPlayback();
              }
            };

            video.addEventListener('loadeddata', handleReady, { once: true });
            video.addEventListener('canplay', handleReady, { once: true });
          }
        };

        const toggleVideo = () => {
          if (video.paused) {
            attemptPlay();
          } else {
            video.pause();
          }
        };

        playButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          toggleVideo();
        });
        video.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          toggleVideo();
        });

        video.addEventListener('play', () => {
          markPlaying(true);
        });

        video.addEventListener('ended', () => {
          markPlaying(false);
        });

        video.addEventListener('pause', () => {
          markPlaying(false);
        });
      });
    }

    handleResize() {
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          this.setInitialPosition(); // Recalculate and reset position
        }, 250);
      });
    }
  }

  function lazyInitCarousels(root = document) {
    const carousels = root.querySelectorAll('.video-testimonials-carousel');
    const initCarousel = (carousel) => {
      if (!carousel || carousel.dataset.lazyInitialized === 'true') return;
      carousel.dataset.lazyInitialized = 'true';
      new TestimonialOption2Carousel(carousel);
    };

    if (Shopify?.designMode) {
      carousels.forEach(initCarousel);
      return;
    }

    if (!('IntersectionObserver' in window)) {
      carousels.forEach(initCarousel);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          initCarousel(entry.target);
        });
      },
      { rootMargin: '300px 0px' }
    );

    carousels.forEach((carousel) => observer.observe(carousel));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => lazyInitCarousels(), { once: true });
  } else {
    lazyInitCarousels();
  }

  document.addEventListener('lazy-section-blocks:load', (event) => {
    lazyInitCarousels(event.target);
  });

  if (Shopify?.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      lazyInitCarousels(event.target);
    });

    document.addEventListener('shopify:block:select', (event) => {
      const carousel = event.target.closest('.video-testimonials-carousel');
      if (carousel) {
        const track = carousel.querySelector('.video-testimonials-track');
        const slides = Array.from(track.children).filter((slide) => !slide.classList.contains('is-clone'));
        const index = slides.indexOf(event.target);
        if (index !== -1) {
          const instance = carousel.__instance; // Assuming instance is stored
          if (instance) {
            instance.currentSlideIndex = index;
            instance.updateCarousel(false);
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gutpet-testimonial"] && !Shopify.designMode) return;
  try {
    
  class TestimonialCarousel {
    constructor(container) {
      this.container = container;
      this.track = container.querySelector('.testimonial-track');
      this.originalSlides = Array.from(this.track.children);
      this.allSlides = this.originalSlides;
      this.prevBtn = container.querySelector('.testimonial-arrow--prev');
      this.nextBtn = container.querySelector('.testimonial-arrow--next');

      this.currentIndex = 0;
      this.autoplaySpeed = parseInt(container.dataset.autoplay) || 5000;
      this.enableAutoplay = container.dataset.enableAutoplay !== 'false';
      this.autoplayTimer = null;
      this.isTransitioning = false;
      this.isVideoPlaying = false;

      this.init();
    }

    init() {
      if (this.originalSlides.length === 0) return;

      this.setupClones();
      this.allSlides = Array.from(this.track.children);
      this.setInitialPosition();

      this.prevBtn?.addEventListener('click', () => this.prev());
      this.nextBtn?.addEventListener('click', () => this.next());

      this.addSwipeSupport();
      this.setupVideoControls();
      // this.setupSlideNavigation(); // Disabled click-to-navigate as per user request
      this.setupVisibilityObserver();
      this.startAutoplay();

      this.container.addEventListener('mouseenter', () => this.stopAutoplay());
      this.container.addEventListener('mouseleave', () => {
        if (!this.isVideoPlaying) this.startAutoplay();
      });

      this.handleResize();
    }

    // ─── Clone & Preload ────────────────────────────────────────────────────

    setupClones() {
      if (this.originalSlides.length <= 1) return;

      const fragmentEnd = document.createDocumentFragment();
      const fragmentStart = document.createDocumentFragment();

      this.originalSlides.forEach((slide) => {
        const cloneEnd = slide.cloneNode(true);
        cloneEnd.classList.add('is-clone');
        cloneEnd.setAttribute('aria-hidden', 'true');
        cloneEnd.setAttribute('inert', '');
        this.#eagerLoadVideo(cloneEnd);
        fragmentEnd.appendChild(cloneEnd);

        const cloneStart = slide.cloneNode(true);
        cloneStart.classList.add('is-clone');
        cloneStart.setAttribute('aria-hidden', 'true');
        cloneStart.setAttribute('inert', '');
        this.#eagerLoadVideo(cloneStart);
        fragmentStart.appendChild(cloneStart);
      });

      this.track.appendChild(fragmentEnd);
      this.track.insertBefore(fragmentStart, this.track.firstChild);
    }

    #eagerLoadVideo(el) {
      const video = el.querySelector('video');
      if (!video) return;
      video.removeAttribute('autoplay');
      video.preload = 'none';
      const sources = video.querySelectorAll('source[data-src]');
      sources.forEach((s) => {
        s.src = s.dataset.src;
        s.removeAttribute('data-src');
      });
      if (sources.length > 0) {
        video.dataset.loaded = 'true';
        video.load();
      }
    }

    #preloadSlide(slide) {
      const video = slide.querySelector('video');
      if (!video || video.dataset.loaded) return;
      video.preload = 'none';
      const sources = video.querySelectorAll('source[data-src]');
      sources.forEach((s) => {
        s.src = s.dataset.src;
        s.removeAttribute('data-src');
      });
      if (sources.length > 0) {
        video.dataset.loaded = 'true';
        video.load();
      }
    }

    #scheduleFullPreload() {
      this.originalSlides.forEach((slide, i) => {
        setTimeout(() => this.#preloadSlide(slide), i * 50);
      });
    }

    // ─── Position & Layout ──────────────────────────────────────────────────

    setInitialPosition() {
      this.currentIndex = 0;
      this.track.style.transition = 'none';
      this.track.style.transform = `translateX(${this.#calcOffset().toFixed(2)}px)`;
      this.updateSlideStates(this.getVisibleSlides());
      this.updateArrowState();
    }

    #domIndex() {
      return this.currentIndex + this.originalSlides.length;
    }

    #calcOffset() {
      const slideWidth = this.getSlideWidth();
      const gap = this.getGap();
      const containerCenter = this.container.offsetWidth / 2;
      const centerMargin = this.getCenterMargin();
      const slideCenterInTrack = this.#domIndex() * (slideWidth + gap) + slideWidth / 2 + centerMargin;
      return containerCenter - slideCenterInTrack;
    }

    getVisibleSlides() {
      const width = window.innerWidth;
      if (width <= 749) return 3;
      if (width <= 989) return 3;
      return 5;
    }

    updateCarousel(animate = true) {
      this.pauseAllVideos();

      if (animate && !this.isTransitioning) {
        this.track.style.transition = 'transform 0.6s cubic-bezier(0.2, 1, 0.3, 1)';
        this.isTransitioning = true;
        setTimeout(() => {
          this.isTransitioning = false;
        }, 600);
      } else {
        this.track.style.transition = 'none';
      }

      this.track.style.transform = `translateX(${this.#calcOffset().toFixed(2)}px)`;
      this.updateSlideStates(this.getVisibleSlides());
      this.updateArrowState();
    }

    updateSlideStates(visibleSlides) {
      const halfVisible = Math.floor(visibleSlides / 2);
      const domCenter = this.#domIndex();

      this.allSlides.forEach((slide, domIdx) => {
        const distance = Math.abs(domIdx - domCenter);
        slide.classList.remove('is-center', 'is-visible', 'is-hidden');

        if (domIdx === domCenter) {
          slide.classList.add('is-center', 'is-visible');
          slide.setAttribute('aria-hidden', 'false');
          slide.removeAttribute('inert');
        } else if (distance <= halfVisible) {
          slide.classList.add('is-visible');
          slide.setAttribute('aria-hidden', 'false');
          slide.removeAttribute('inert');
        } else {
          slide.classList.add('is-hidden');
          slide.setAttribute('aria-hidden', 'true');
          slide.setAttribute('inert', '');
        }
      });
    }

    updateArrowState() {
      const disable = this.originalSlides.length <= 1;
      if (this.prevBtn) this.prevBtn.disabled = disable;
      if (this.nextBtn) this.nextBtn.disabled = disable;
    }

    // ─── Navigation ─────────────────────────────────────────────────────────

    next() {
      if (this.isTransitioning) return;
      if (this.originalSlides.length === 1) return;

      this.pauseAllVideos();
      this.currentIndex++;
      this.updateCarousel(true);

      if (this.currentIndex >= this.originalSlides.length) {
        setTimeout(() => this.#silentJump(0), 600);
      }
    }

    prev() {
      if (this.isTransitioning) return;
      if (this.originalSlides.length === 1) return;

      this.pauseAllVideos();
      this.currentIndex--;
      this.updateCarousel(true);

      if (this.currentIndex < 0) {
        setTimeout(() => this.#silentJump(this.originalSlides.length - 1), 600);
      }
    }

    // Teleport to targetIndex with zero visual flash:
    // freeze all CSS transitions → move → re-enable next paint
    #silentJump(targetIndex) {
      // Freeze slide-level transitions (scale, opacity…) AND track
      this.allSlides.forEach((s) => (s.style.transition = 'none'));
      this.track.style.transition = 'none';

      this.currentIndex = targetIndex;
      this.track.style.transform = `translateX(${this.#calcOffset().toFixed(2)}px)`;

      this.updateSlideStates(this.getVisibleSlides());
      this.updateArrowState();

      // Re-enable transitions after 2 frames (enough for browser to paint)
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.allSlides.forEach((s) => (s.style.transition = ''));
        });
      });
    }

    navigateToSlide(targetIndex) {
      if (this.isTransitioning) return;
      if (targetIndex === this.currentIndex) return;

      this.pauseAllVideos();
      this.currentIndex = targetIndex;
      this.updateCarousel(true);

      setTimeout(() => {
        const centerSlide = this.originalSlides[this.currentIndex];
        const video = centerSlide?.querySelector('video[data-manual-play]');
        if (video && video.paused) {
          video.muted = false;
          let playPromise = video.play();
          if (playPromise !== undefined) {
             playPromise.catch(() => { video.muted = true; video.play(); });
          }
          video.classList.add('is-playing');
          this.isVideoPlaying = true;
          this.stopAutoplay();
        }
      }, 600);
    }

    setupSlideNavigation() {
      this.originalSlides.forEach((slide, index) => {
        slide.addEventListener('click', (e) => {
          // On touch devices: disable click-to-navigate (use swipe/arrows only)
          if ('ontouchstart' in window) return;
          // Ignore clicks originating from video or any button
          if (e.target.closest('video, .video-play-button, button')) return;
          if (index === this.currentIndex) return;
          this.navigateToSlide(index);
        });
      });
    }

    // ─── Video Controls ──────────────────────────────────────────────────────

    setupVideoControls() {
      const manualVideos = this.container.querySelectorAll('.testimonial-slide:not(.is-clone) video[data-manual-play]');

      manualVideos.forEach((video) => {
        const mediaContainer = video.closest('.testimonial-media');
        const playButton = mediaContainer?.querySelector('.video-play-button');
        const slide = video.closest('.testimonial-slide');

        if (!playButton || !slide) return;

        const toggleVideo = () => {
          if (!slide.classList.contains('is-center')) return;

          if (video.paused) {
            if (video.readyState === 0) video.load();
            video.muted = false;
            let playPromise = video.play();
            if (playPromise !== undefined) {
               playPromise.catch(() => { video.muted = true; video.play(); });
            }
            video.classList.add('is-playing');
            this.isVideoPlaying = true;
            this.stopAutoplay();
          } else {
            video.pause();
            video.classList.remove('is-playing');
            this.isVideoPlaying = false;
            this.startAutoplay();
          }
        };

        playButton.addEventListener('click', (e) => {
          e.stopPropagation();
          toggleVideo();
        });
        video.addEventListener('click', (e) => {
          e.stopPropagation();
          toggleVideo();
        });

        video.addEventListener('ended', () => {
          video.classList.remove('is-playing');
          this.isVideoPlaying = false;
          this.startAutoplay();
        });

        video.addEventListener('pause', () => {
          video.classList.remove('is-playing');
          this.isVideoPlaying = false;
        });
      });
    }

    // ─── Autoplay ────────────────────────────────────────────────────────────

    startAutoplay() {
      if (!this.enableAutoplay) return;
      if (this.originalSlides.length <= 1) return;
      this.stopAutoplay();
      this.autoplayTimer = setInterval(() => this.next(), this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    pauseAllVideos() {
      this.container.querySelectorAll('video').forEach((v) => {
        if (!v.paused) {
          v.pause();
          v.classList.remove('is-playing');
        }
      });
    }

    // ─── Swipe ───────────────────────────────────────────────────────────────

    addSwipeSupport() {
      let startX = 0;
      let startY = 0;
      let currentX = 0;
      let isDragging = false;
      let isHorizontal = null;
      let baseOffset = 0;

      const getBaseOffset = () => {
        const m = this.track.style.transform.match(/translateX\(([\d.-]+)px\)/);
        return m ? parseFloat(m[1]) : 0;
      };

      const targets = [this.track];
      targets.forEach((el) => {
        el.addEventListener(
          'touchstart',
          (e) => {
            const touch = e.touches[0];
            startX = touch.clientX;
            startY = touch.clientY;
            currentX = startX;
            isDragging = true;
            isHorizontal = null;
            this.track.style.transition = 'none';
            baseOffset = getBaseOffset();
            this.isTransitioning = false;
            this.stopAutoplay();
          },
          { passive: true }
        );

        el.addEventListener(
          'touchmove',
          (e) => {
            if (!isDragging) return;
            const touch = e.touches[0];
            const dx = touch.clientX - startX;
            const dy = touch.clientY - startY;

            if (isHorizontal === null) {
              if (Math.abs(dx) > Math.abs(dy) + 3) {
                isHorizontal = true;
              } else if (Math.abs(dy) > Math.abs(dx) + 3) {
                isHorizontal = false;
              }
            }
            if (isHorizontal === false) return;
            if (isHorizontal) e.preventDefault();

            currentX = touch.clientX;
            const drag = currentX - startX;
            this.track.style.transform = `translateX(${(baseOffset + drag).toFixed(2)}px)`;
          },
          { passive: false }
        );

        const onEnd = () => {
          if (!isDragging) return;
          isDragging = false;
          isHorizontal = null;

          const diff = startX - currentX;
          if (Math.abs(diff) > 40) {
            if (diff > 0) {
              this.next();
            } else {
              this.prev();
            }
          } else {
            this.updateCarousel(true);
          }
          this.startAutoplay();
        };

        el.addEventListener('touchend', onEnd);
        el.addEventListener('touchcancel', onEnd);
      });
    }

    // ─── Visibility & Preload ─────────────────────────────────────────────────

    setupVisibilityObserver() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.#scheduleFullPreload();
            } else {
              this.pauseAllVideos();
              this.startAutoplay();
            }
          });
        },
        { rootMargin: '50px', threshold: 0.1 }
      );
      observer.observe(this.container);
      setTimeout(() => this.#scheduleFullPreload(), 200);
    }

    // ─── Resize ───────────────────────────────────────────────────────────────

    handleResize() {
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => this.updateCarousel(false), 250);
      });
    }

    // ─── Helpers ──────────────────────────────────────────────────────────────

    getSlideWidth() {
      const firstSlide = this.allSlides[0];
      if (firstSlide) return firstSlide.offsetWidth;
      const width = window.innerWidth;
      if (width <= 749) return Math.min(width - 32, 320);
      if (width <= 989) return 256;
      return 224;
    }

    getGap() {
      return window.innerWidth <= 749 ? 16 : 24;
    }

    getCenterMargin() {
      const width = window.innerWidth;
      if (width <= 749) return 16;
      if (width <= 989) return 46;
      if (width >= 1400) return 46;
      return 36;
    }

    destroy() {
      this.stopAutoplay();
    }
  }

  function lazyInitCarousels(root = document) {
    const carousels = root.querySelectorAll('.testimonial-carousel');
    const initCarousel = (carousel) => {
      if (!carousel || carousel.dataset.lazyInitialized === 'true') return;
      carousel.dataset.lazyInitialized = 'true';
      new TestimonialCarousel(carousel);
    };

    if (Shopify?.designMode) {
      carousels.forEach(initCarousel);
      return;
    }

    if (!('IntersectionObserver' in window)) {
      carousels.forEach(initCarousel);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          initCarousel(entry.target);
        });
      },
      { rootMargin: '300px 0px' }
    );

    carousels.forEach((carousel) => observer.observe(carousel));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => lazyInitCarousels(), { once: true });
  } else {
    lazyInitCarousels();
  }

  if (Shopify?.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      lazyInitCarousels(event.target);
    });
    document.addEventListener('shopify:block:select', (event) => {
      const carousel = event.target.closest('.testimonial-carousel');
      if (carousel) carousel.__carousel?.stopAutoplay();
    });
  }

  } catch(e) { console.error(e); }
})();
})();
